import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import { getLocalAndParentRank } from './getLocalAndParentRank';
function removeLeadingZerosFromRank(rank) {
  return rank.split('.').map(function (level) {
    return Number(level).toString();
  }).filter(function (level) {
    return level !== '0';
  }).join('.');
}
export function augmentPlaylistContentWithParentId(contents) {
  var contentsWithCleanRanks = contents.map(function (content) {
    return _objectSpread(_objectSpread({}, content), {}, {
      rank: removeLeadingZerosFromRank(content.rank)
    });
  });
  var rankToIdMap = new Map(contentsWithCleanRanks.map(function (_ref) {
    var rank = _ref.rank,
      id = _ref.id;
    return [rank, id];
  }));
  return contentsWithCleanRanks.map(function (content) {
    var _getLocalAndParentRan = getLocalAndParentRank(content.rank),
      rankInSection = _getLocalAndParentRan.rankInSection,
      parentRank = _getLocalAndParentRan.parentRank;
    var parent_id = parentRank ? rankToIdMap.get(parentRank) : undefined;
    return _objectSpread(_objectSpread({}, content), {}, {
      rankInSection: rankInSection,
      parent_id: parent_id
    });
  });
}